import styled from 'styled-components';
import IconComponent from '../CommonComponents/Icon';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 64px;
`;

export const Icon = styled(IconComponent)`
  color: #cbc9c9;
  font-size: 96px;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 32px;
  text-align: center;
  color: #444444;
  margin: 40px 0 16px 0;
`;

export const Message = styled.p`
  font-weight: 600;
  font-size: 16px;
  color: #767676;
  max-width: 600px;
  text-align: center;
  margin: 0 0 48px 0;
  line-height: 32px;
`;

export const Contact = styled.a`
  color: #318dea;
  transition: color 0.1s ease;
  &:hover {
    color: #1573d3;
  }
`;
